import request from './request';

// 业务订单导入

/**
 * 业务订单导入-列表
 */
export function getImportList(params) {
    return request('/booking-order/import-record/list', {
        method: 'POST',
        params,
    });
}
/**
 * 业务订单导入-保养订单导入
 */

export function importData(params) {
    return request('/booking-order/import', {
        method: 'POST',
        params,
        headers: {
            'Content-Type': 'multipart/form-data',
            // 是否取消统一报错提示
            'Cancel-Message': true,
        },
    });
}
